import { computed, inject, Injectable, signal } from '@angular/core';
import { deepEqual } from 'fast-equals';
import { ExchangeRatesApiService } from '../services/exchange-rates-api.service';
import { mergeState } from '../utils/signals.util';
import { StateStorage, StorageStrategy } from '../utils/state-storage.util';

export interface ExchangeRatesShape {
  yearly?: Record<string, number> | null;
  daily?: Record<string, number> | null;
  source?: string | null;
}

const initState: ExchangeRatesShape = {
  yearly: null,
  daily: null,
  source: null,
};

@Injectable({
  providedIn: 'root',
})
export class ExchangeRatesState {
  readonly yearly = computed(() => this.state().yearly, { equal: deepEqual });
  readonly daily = computed(() => this.state().daily, { equal: deepEqual });
  readonly source = computed(() => this.state().source, { equal: deepEqual });

  private readonly state = signal({ ...initState });
  private readonly exchangeRatesApi = inject(ExchangeRatesApiService);

  constructor() {
    StateStorage.init(
      this.state,
      'exchangeRates',
      StorageStrategy.LocalStorage,
    );
  }

  async fetchExchangeRates(): Promise<void> {
    const [daily, yearly] = await Promise.all([
      this.exchangeRatesApi.getDailyExchangeRate(124),
      this.exchangeRatesApi.getYearlyExchangeRate(124),
    ]);

    const exchangeRates: ExchangeRatesShape = {
      source: daily?.source,
      daily: daily?.exchangeRates,
      yearly,
    };

    mergeState(this.state, {
      ...exchangeRates,
    });
  }
}
